import surveyAPI from 'api/base';

import {
  SendPaymentInformation,
  GetContent,
  SendFeedbackInformation,
  SendAvailability,
  SendContactData,
  SendContact,
  GetAvailability,
  PostConsultation,
  FinishCustomBlock,
} from './types';

export const sendPaymentInformation: SendPaymentInformation = (url, data) => {
  const { email, optIn, phone, paymentUrl } = data;
  const requestData = {
    request_url: url,
    email,
    phone,
    ...(typeof optIn === 'boolean' ? { did_opt_in: optIn } : {}),
  };

  return surveyAPI.post(paymentUrl, requestData);
};

export const sendFeedbackInformation: SendFeedbackInformation = (data) => {
  return surveyAPI.put(`/surveys:feedback/`, data);
};

export const sendAvailability: SendAvailability = (data) => {
  return surveyAPI.put(`/respondent/${data.id}/availability/`, data);
};

export const getAvailability: GetAvailability = (data) => {
  return surveyAPI.get(`/respondent/${data}/availability/`);
};

export const finishConsultation: PostConsultation = (data) => {
  return surveyAPI.post(`/surveys:finalize_consultation_application/`, data);
};

export const finishCustomBlock: FinishCustomBlock = (data) => {
  return surveyAPI.post(`/surveys:custom_block_completion/`, data);
};

export const sendContactInfo: SendContact = (data) => {
  return surveyAPI.put(`/respondent/${data.id}/contact_information/`, data);
};

export const getContent: GetContent = (url) => {
  return surveyAPI.get(`/surveys:content/?survey_url=${encodeURIComponent(url)}`);

  // return Promise.resolve({
  //   is_allowed: true,
  //   content: {
  //     heading:
  //       'some heading [paymentEmailEntry] [referralLinkWithButton] [referralLinkReferralProgramButton]',
  //     subheading: 'some sub heading',
  //     terms_message: 'some message',
  //     opt_in_message: 'some message',
  //     end_message: 'some message',
  //     referral_message: 'some message',
  //   },
  //   redirect_to: null,
  //   alert_msg: 'some message',
  //   alert_level: 'error',
  //   subject: 'some sub',
  //   subject_type: 'referee',
  //   current_flow: 'MAIN',
  //   ui_specs: {
  //     should_show_opt_in: true,
  //     should_show_terms: true,
  //   },
  //   block_type: 'CUSTOM',
  // } as SurveyContent);
};
